import type { ITheme } from "survey-core";

export const themeJson: ITheme = {
  cssVariables: {
    "--sjs-general-backcolor": "rgba(255, 255, 255, 1)",
    "--sjs-general-backcolor-dark": "rgba(248, 248, 248, 1)",
    "--sjs-general-backcolor-dim": "transparent",
    "--sjs-general-backcolor-dim-light": "rgba(255, 255, 255, 1)",
    "--sjs-general-backcolor-dim-dark": "white",
    "--sjs-general-forecolor": "rgba(0, 0, 0, 0.91)",
    "--sjs-general-forecolor-light": "rgba(0, 0, 0, 0.45)",
    "--sjs-general-dim-forecolor": "rgba(0, 0, 0, 0.91)",
    "--sjs-general-dim-forecolor-light": "rgba(0, 0, 0, 0.45)",

    "--sjs-primary-backcolor": "#4B5D6D",
    "--sjs-primary-backcolor-light": "#1e6b91",
    "--sjs-primary-backcolor-dark": "rgba(65, 80, 94, 1)",
    "--sjs-primary-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-primary-forecolor-light": "rgba(255, 255, 255, 0.25)",

    "--sjs-base-unit": "6px",
    "--sjs-corner-radius": "4px",

    "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
    "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
    "--sjs-secondary-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-secondary-forecolor-light": "rgba(255, 255, 255, 0.25)",

    "--sjs-shadow-small":
      "0px 0px 0px 1px rgba(0, 0, 0, 0.03), 0px 1px 3px 0px rgba(0, 0, 0, 0.1), 0px 8px 16px 0px rgba(0, 0, 0, 0.05)",
    "--sjs-shadow-medium": "0px 2px 6px 0px rgba(0, 0, 0, 0.1)",
    "--sjs-shadow-large": "0px 8px 16px 0px rgba(0, 0, 0, 0.1)",
    "--sjs-shadow-inner":
      "0px 0px 0px 1px rgba(0, 0, 0, 0.03), 0px 1px 3px 0px rgba(0, 0, 0, 0.1), 0px 8px 16px 0px rgba(0, 0, 0, 0.05)",

    "--sjs-special-red": "rgba(229, 10, 62, 1)",
    "--sjs-special-red-light": "rgba(229, 10, 62, 0.1)",
    "--sjs-special-red-forecolor": "rgba(255, 255, 255, 1)",

    "--sjs-special-green": "rgba(25, 179, 148, 1)",
    "--sjs-special-green-light": "rgba(25, 179, 148, 0.1)",
    "--sjs-special-green-forecolor": "rgba(255, 255, 255, 1)",

    "--sjs-special-blue": "rgba(67, 127, 217, 1)",
    "--sjs-special-blue-light": "rgba(67, 127, 217, 0.1)",
    "--sjs-special-blue-forecolor": "rgba(255, 255, 255, 1)",

    "--sjs-special-yellow": "rgba(255, 152, 20, 1)",
    "--sjs-special-yellow-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-special-yellow-forecolor": "rgba(255, 255, 255, 1)",

    "--sjs-font-default-size": "12px",
    "--sjs-font-questiontitle-size": "12px",
    "--sjs-font-questiondescription-size": "12px",
    "--sjs-font-label-size": "12px",

    "--sjs-font-pagetitle-size": "14px",
    "--sjs-font-headertitle-size": "32px",
    "--sjs-font-headerdescription-size": "14px",

    "--sjs-editor-background": "rgba(255, 255, 255, 1)",
    "--sjs-editorpanel-hovercolor": "rgba(241, 244, 246, 1)",
    "--sjs-font-editorfont-placeholdercolor": "rgba(0, 0, 0, 0.5)",
    "--sjs-font-editorfont-color": "rgba(0, 0, 0, 0.9)",

    "--sjs-question-background": "rgba(255, 255, 255, 1)",
    "--sjs-questionpanel-hovercolor": "rgba(241, 244, 246, 1)",

    "--sjs-header-backcolor": "transparent",
    "-sd-base-vertical-padding": "2px"
  },

  isPanelless: true,
  themeName: "default",
  colorPalette: "light",

  header: {
    height: 40,
    textAreaWidth: 280,
    inheritWidthFrom: "survey",
    titlePositionX: "left",
    titlePositionY: "middle",
    descriptionPositionX: "right",
    descriptionPositionY: "middle"
  },

  headerView: "advanced"
};


export const customThemeVariables: Record<string, string> = {
  // Primary colors (buttons, active states)
  "--sjs-primary-background-500": "#1e6b91",

  // Secondary colors (accents, highlights)
  "--sjs-secondary-background-500": "#2b4c63",

  // Background layers
  "--sjs-layer-1-background-500": "#FFFFFFFF",
  "--sjs-layer-2-background-500": "#F2F6FDFF",
  "--sjs-layer-3-background-500": "#EAF0FBFF",

  // Text colors
  "--sjs-layer-1-foreground-100": "#122243FF",

  // Semantic colors (status indicators)
  "--sjs-semantic-red-background-500": "#D6378AFF",
  "--sjs-semantic-green-background-500": "#19B394FF",
  "--sjs-semantic-blue-background-500": "#437FD9FF",

  // Fixed Scale Values
  "--ctr-size-unit": "4.4px",
  "--ctr-spacing-unit": "4.4px",
  "--ctr-corner-radius-unit": "4.4px",

  "--ctr-font-unit": "6px",
  "--ctr-line-height-unit": "6px",
};
